import React from "react";
import { Link } from "react-router-dom";

const DrinkCard = ({ drink }) => {
  const { _id, image, name, steps } = drink;

  let imageToUse = image;
  if (!image || image.length <= 1) {
    const placeholder = `${process.env.PUBLIC_URL}/placeholder.png`;
    imageToUse = placeholder;
  }

  const renderStepsHint = steps => {
    const stepText = `step${steps.length > 1 ? "s" : ""}`; // handle plural/singular
    return `${steps.length} ${stepText}`;
  };

  return (
    <Link to={`/drinks/${_id}`} className="ui card">
      <div className="image">
        <img src={imageToUse} alt={name} />
      </div>
      <div className="content">
        <div className="header">{name}</div>
      </div>
      <div className="extra content">
        <i className="list icon"></i>
        {renderStepsHint(steps)}
      </div>
    </Link>
  );
};

export default DrinkCard;
